import 'jquery'
import './style.scss'

import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import archiveWine from './routes/archiveWine'
import singleWine from './routes/singleWine'
import templateModulable from './routes/templateModulable'
import contact from './routes/contact'

const checkMobile = () => {
  if (document.documentElement.clientWidth <= 768) {
    window.IS_MOBILE = true
  } else {
    window.IS_MOBILE = false
  }
}

checkMobile()

window.addEventListener('resize', () => {
  checkMobile()
})

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  home,
  postTypeArchiveWine: archiveWine,
  taxWineCategory: archiveWine,
  singleWine,
  pageTemplateTemplatePageModulable: templateModulable,
  pageTemplateTemplateContact: contact
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents())
